
import { css } from 'lit';
export default css`
table, .table--default {
  display: block;
  width: 100%;
  max-width: 100%;
  overflow-x: auto;
  font-family: Lato, sans-serif;
}

  table td, .table--default td {
  font-size: 1.125rem;
}

  table td, .table--default td {
  --tw-text-opacity: 1;
  color: rgba(35, 35, 35, var(--tw-text-opacity));
}

  table th, table td, .table--default th, .table--default td {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

  table th, table td, .table--default th, .table--default td {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

  @media (min-width: 768px) {

  table th, table td, .table--default th, .table--default td {
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }
}

  @media (min-width: 1024px) {

  table th, table td, .table--default th, .table--default td {
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }
}

  table th.table__cell--no-wrap, table td.table__cell--no-wrap, .table--default th.table__cell--no-wrap, .table--default td.table__cell--no-wrap {
  white-space: nowrap;
}

  table th.table__cell--min-w-sm, table td.table__cell--min-w-sm, .table--default th.table__cell--min-w-sm, .table--default td.table__cell--min-w-sm {
      min-width: 180px;
    }

  table th.table__cell--min-w-md, table td.table__cell--min-w-md, .table--default th.table__cell--min-w-md, .table--default td.table__cell--min-w-md {
      min-width: 300px;
    }

  table th.table__cell--min-w-lg, table td.table__cell--min-w-lg, .table--default th.table__cell--min-w-lg, .table--default td.table__cell--min-w-lg {
      min-width: 420px;
    }

  table tr, .table--default tr {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 242, 242, var(--tw-bg-opacity));
}

  table thead tr, .table--default thead tr {
  --tw-bg-opacity: 1;
  background-color: rgba(53, 25, 108, var(--tw-bg-opacity));
}

  table thead th, .table--default thead th {
  font-size: 1.25rem;
}

  table thead th, .table--default thead th {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  table tr:nth-child(even), .table--default tr:nth-child(even) {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

  table th:first-child, table td:first-child, .table--default th:first-child, .table--default td:first-child {
  padding-left: 1rem;
}

  table th:last-child, table td:last-child, .table--default th:last-child, .table--default td:last-child {
  padding-right: 1rem;
}

@media screen and (max-width: 640px) {
  table,
  .table--default {
    border: 0;
    display: grid;
  }

    table thead, .table--default thead {
    display: none;
  }

    table tr, .table--default tr {
    margin-bottom: 0.625rem;
  }

    table tr, .table--default tr {
    display: block;
  }

    table tr, .table--default tr {
    border-width: 1px;
  }

    table tr, .table--default tr {
    border-bottom-width: 4px;
  }

    table tr, .table--default tr {
      border-color: #ddd;
    }

    table td, .table--default td {
    display: block;
  }

    table td, .table--default td {
    border-bottom-width: 1px;
  }

    table td, .table--default td {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

    table td, .table--default td {
    padding-left: 1rem;
    padding-right: 1rem;
  }

    table td, .table--default td {
    text-align: right;
  }

    table td, .table--default td {
      border-color: #ddd;
    }

      /*
      * aria-label has no advantage, it won't be read inside a table
      * content: attr(aria-label);
      */
      table td:before, .table--default td:before {
        content: attr(data-label);
      }
      table td:before, .table--default td:before {
    display: flex;
  }
      table td:before, .table--default td:before {
    flex-direction: column;
  }
      table td:before, .table--default td:before {
    font-size: 0.9375rem;
  }
      table td:before, .table--default td:before {
    font-weight: 700;
  }
      table td:before, .table--default td:before {
    --tw-text-opacity: 1;
    color: rgba(53, 25, 108, var(--tw-text-opacity));
  }

      table td:first-child, .table--default td:first-child {
    border-top-width: 1px;
  }

      table td:first-child, .table--default td:first-child {
    --tw-border-opacity: 1;
    border-top-color: rgba(242, 242, 242, var(--tw-border-opacity));
  }

      table td:first-child, .table--default td:first-child {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

      table td:first-child, .table--default td:first-child {
    padding-left: 1rem;
    padding-right: 1rem;
  }

      table td:last-child, .table--default td:last-child {
        border-bottom: 0;
      }
}`;